import { render, staticRenderFns } from "./tai-xiu.vue?vue&type=template&id=a81250c2&scoped=true"
import script from "./tai-xiu.vue?vue&type=script&lang=js"
export * from "./tai-xiu.vue?vue&type=script&lang=js"
import style0 from "./tai-xiu.vue?vue&type=style&index=0&id=a81250c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81250c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a81250c2')) {
      api.createRecord('a81250c2', component.options)
    } else {
      api.reload('a81250c2', component.options)
    }
    module.hot.accept("./tai-xiu.vue?vue&type=template&id=a81250c2&scoped=true", function () {
      api.rerender('a81250c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tai-xiu.vue"
export default component.exports